export default __webpack_public_path__ + "170cf09.png";